module.exports = __webpack_public_path__ + "img/o_6.3ee3d90e.png";